import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';

const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getCouponListAPI = async (token) => {
    try {
        const response = await API.get('admin/coupons', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

// Create a new category
export const createCouponAPI = async (formData, token) => {    
    try {
        const response = await API.post('admin/coupons/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data', // Required for file uploads
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error; // Re-throw error for further handling
    }
};

// Create a new category
export const getCouponAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/coupons/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const updateCouponAPI = async (formData, id, token) => {    
    try {
        const response = await API.post(`admin/coupons/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteCouponAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/coupons/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};